import React from 'react';
import { withFormsy } from 'formsy-react';

class Tag extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.state = {
      selected: false
    }
  }

  changeValue(event) {
    this.selected(!this.state.selected)
  }

  selected(selected) {
    let value = this.props.getValue()
    value['selected'] = selected
    this.props.setValue(value);
    this.setState({selected: selected})
  }

  componentWillMount() {
    const {active} = this.props.getValue()
    this.selected(active)
  }

  render() {
    const {name} = this.props.getValue()

    return (
      <div className="tag">
        <label onClick={this.changeValue} className={`pointer ${this.state.selected ? 'new' : ''}`}>{name}</label>
      </div>
    );
  }
}

export default withFormsy(Tag);
